import restApi from '@/rest-api'

export default {
    
    getMembersByFilter(page, filter, sortOption, order) {
        var path = page ? `/member/filtered?page=${page}&per_page=12&` : '/member/filtered?per_page=12'
        if (sortOption) {
            path += `sortOption=${sortOption}&order=${order}`
        }
        return restApi.post(path, filter)
    }

}
